import { render, staticRenderFns } from "./ordersales.vue?vue&type=template&id=27547b73&scoped=true"
import script from "./ordersales.vue?vue&type=script&lang=js"
export * from "./ordersales.vue?vue&type=script&lang=js"
import style0 from "./ordersales.vue?vue&type=style&index=0&id=27547b73&prod&lang=scss"
import style1 from "./ordersales.vue?vue&type=style&index=1&id=27547b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27547b73",
  null
  
)

export default component.exports